var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2132 10.5315C22.536 10.5315 21.6389 10.5165 20.522 10.5165C17.7981 10.5165 15.5583 8.262 15.5583 5.5125V0.6885C15.5583 0.309 15.2538 0 14.8796 0H6.94544C3.24275 0 0.25 3.039 0.25 6.7635V22.926C0.25 26.8335 3.38533 30 7.25437 30H19.0679C22.7587 30 25.75 26.9805 25.75 23.253V11.2065C25.75 10.8255 25.447 10.518 25.0698 10.5195C24.4371 10.524 23.6751 10.5315 23.2132 10.5315Z",
    fill: "#ffbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.126 0.850963C18.6775 0.384463 17.8945 0.705463 17.8945 1.35196V5.30746C17.8945 6.96646 19.261 8.33146 20.9185 8.33146C21.9655 8.34346 23.4175 8.34646 24.6505 8.34346C25.282 8.34196 25.603 7.58746 25.165 7.13146C23.5825 5.48596 20.749 2.53696 19.126 0.850963Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6574 16.3255C17.2209 16.759 16.5144 16.762 16.0764 16.3225L13.6929 13.927V21.1675C13.6929 21.784 13.1919 22.285 12.5754 22.285C11.9589 22.285 11.4594 21.784 11.4594 21.1675V13.927L9.07285 16.3225C8.63785 16.762 7.92985 16.759 7.49335 16.3255C7.05685 15.892 7.05535 15.184 7.49035 14.746L11.7834 10.4335C11.7849 10.432 11.7849 10.432 11.7849 10.432C11.8869 10.33 12.0099 10.2475 12.1449 10.192C12.2799 10.135 12.4269 10.105 12.5754 10.105C12.7254 10.105 12.8724 10.135 13.0074 10.192C13.1409 10.2475 13.2624 10.33 13.3644 10.4305C13.3659 10.432 13.3674 10.432 13.3674 10.4335L17.6604 14.746C18.0954 15.184 18.0954 15.892 17.6574 16.3255Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.eeb5e37d335dc620eb13f7623b8276bb.svg";
export { ForwardRef as ReactComponent };